module.exports = __webpack_public_path__ + "img/C3.57297fbd.svg";